// @flow
import serviceProviderProfile from './common/profileReducer';
import license from './common/licenseReducer';
import { getServiceProvider } from '../../app/common/serviceProvider/serviceProviderReducer';
import showcaseReducer from '../showcase/common/showcaseReducer';

export default {
  beforeConfigureStore: (options: any): {|reducers: any|} => ({
    reducers: {
      ...(options || {}).reducers,
      license,
      serviceProviderProfile,
      serviceProvider: getServiceProvider,
      showcase: showcaseReducer,
    },
  }),
};



// WEBPACK FOOTER //
// ./src/modules/profile/injectors.js